// Разбор ввода и форматирование чисел в калькуляторах.

/**
 * Значение поля → число.
 *
 * Поля калькуляторов — `input[type=number]`, их значение приходит строкой:
 * пустая строка и промежуточные состояния вроде «-» дают 0, как и в прототипе
 * (там `Number('')` тоже давал 0, а вот `Number('-')` печатал «NaN» в результате).
 */
export function parseNumber(value: string): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

/**
 * Число с фиксированной точностью.
 *
 * Отдельно гасится «−0.00»: `(-0.001).toFixed(2)` в JS даёт строку со знаком,
 * а в результатах калькуляторов минус перед нулём читается как ошибка расчёта.
 */
export function formatFixed(value: number, digits = 2): string {
  if (!Number.isFinite(value)) return '—';
  const rounded = Number(value.toFixed(digits));
  return (rounded === 0 ? 0 : value).toFixed(digits);
}
